var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _path, _path2, _path3, _path4, _g9, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMobile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 430,
    height: 415,
    viewBox: "0 0 430 415",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M163.633 118.196L138.685 132.58L79.8008 98.4182L105.647 84.0342L163.633 118.196Z",
    stroke: "white",
    strokeWidth: 1.14653,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.633 194.162L138.685 208.546L79.8008 174.384L105.647 160L163.633 194.162Z",
    stroke: "white",
    strokeWidth: 1.14653,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.49 194.162L138.543 208.546L79.6582 174.384L105.505 160L163.49 194.162Z",
    stroke: "white",
    strokeWidth: 1.14653,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.684 132.58V208.546",
    stroke: "white",
    strokeWidth: 1.14653,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.872 84.0342V160L79.8262 174.359V98.3932",
    stroke: "white",
    strokeWidth: 1.14653,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.633 117.946V193.912",
    stroke: "white",
    strokeWidth: 1.14653,
    strokeMiterlimit: 10
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M113.974 146.266L89.0272 160.65L30.1426 126.488L55.9889 112.104L113.974 146.266Z",
    stroke: "white",
    strokeWidth: 1.14651,
    strokeMiterlimit: 10,
    strokeDasharray: "3.8 3.8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.974 222.231L89.0272 236.615L30.1426 202.453L55.9889 188.069L113.974 222.231Z",
    stroke: "#231F20",
    strokeWidth: 1.14651,
    strokeMiterlimit: 10,
    strokeDasharray: "3.8 3.8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.832 222.232L88.8846 236.616L30 202.454L55.8463 188.07L113.832 222.232Z",
    stroke: "white",
    strokeWidth: 1.14651,
    strokeMiterlimit: 10,
    strokeDasharray: "3.8 3.8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.0254 160.649V236.615",
    stroke: "white",
    strokeWidth: 1.14651,
    strokeMiterlimit: 10,
    strokeDasharray: "3.8 3.8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.214 112.104V188.069L30.168 202.428V126.463",
    stroke: "white",
    strokeWidth: 1.14651,
    strokeMiterlimit: 10,
    strokeDasharray: "3.8 3.8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.975 146.016V221.981",
    stroke: "white",
    strokeWidth: 1.14651,
    strokeMiterlimit: 10,
    strokeDasharray: "3.8 3.8"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M322.697 156.181L297.75 170.565L238.865 136.403L264.712 122.019L322.697 156.181Z",
    stroke: "white",
    strokeWidth: 1.14653,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.697 232.146L297.75 246.53L238.865 212.368L264.712 197.984L322.697 232.146Z",
    stroke: "white",
    strokeWidth: 1.14653,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.555 232.147L297.607 246.531L238.723 212.369L264.569 197.985L322.555 232.147Z",
    stroke: "white",
    strokeWidth: 1.14653,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.748 170.564V246.53",
    stroke: "white",
    strokeWidth: 1.14653,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.937 122.019V197.984L238.891 212.343V136.378",
    stroke: "white",
    strokeWidth: 1.14653,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.697 155.931V231.896",
    stroke: "white",
    strokeWidth: 1.14653,
    strokeMiterlimit: 10
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M400 199.04L375.053 213.424L316.168 179.262L342.014 164.878L400 199.04Z",
    stroke: "white",
    strokeWidth: 1.14651,
    strokeMiterlimit: 10,
    strokeDasharray: "3.8 3.8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400 275.006L375.053 289.39L316.168 255.228L342.014 240.844L400 275.006Z",
    stroke: "#231F20",
    strokeWidth: 1.14651,
    strokeMiterlimit: 10,
    strokeDasharray: "3.8 3.8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.857 275.006L374.91 289.39L316.025 255.228L341.872 240.844L399.857 275.006Z",
    stroke: "white",
    strokeWidth: 1.14651,
    strokeMiterlimit: 10,
    strokeDasharray: "3.8 3.8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.051 213.424V289.389",
    stroke: "white",
    strokeWidth: 1.14651,
    strokeMiterlimit: 10,
    strokeDasharray: "3.8 3.8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.239 164.878V240.844L316.193 255.203V179.237",
    stroke: "white",
    strokeWidth: 1.14651,
    strokeMiterlimit: 10,
    strokeDasharray: "3.8 3.8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400 198.79V274.756",
    stroke: "white",
    strokeWidth: 1.14651,
    strokeMiterlimit: 10,
    strokeDasharray: "3.8 3.8"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M183.918 104.802L208.865 119.186L267.75 85.0237L241.904 70.6396L183.918 104.802Z",
    stroke: "white",
    strokeWidth: 1.14653,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.918 180.768L208.865 195.152L267.75 160.99L241.904 146.606L183.918 180.768Z",
    stroke: "white",
    strokeWidth: 1.14653,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.061 180.768L209.008 195.152L267.892 160.99L242.046 146.605L184.061 180.768Z",
    stroke: "white",
    strokeWidth: 1.14653,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.865 119.186V195.151",
    stroke: "white",
    strokeWidth: 1.14653,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.68 70.6396V146.605L267.726 160.964V84.9987",
    stroke: "white",
    strokeWidth: 1.14653,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.918 104.552V180.518",
    stroke: "white",
    strokeWidth: 1.14653,
    strokeMiterlimit: 10
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M129.016 70.5751L153.963 84.9592L212.848 50.7971L187.001 36.4131L129.016 70.5751Z",
    stroke: "white",
    strokeWidth: 1.14651,
    strokeMiterlimit: 10,
    strokeDasharray: "3.8 3.8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.016 146.541L153.963 160.925L212.848 126.763L187.001 112.379L129.016 146.541Z",
    stroke: "#231F20",
    strokeWidth: 1.14651,
    strokeMiterlimit: 10,
    strokeDasharray: "3.8 3.8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.158 146.541L154.106 160.925L212.99 126.763L187.144 112.379L129.158 146.541Z",
    stroke: "white",
    strokeWidth: 1.14651,
    strokeMiterlimit: 10,
    strokeDasharray: "3.8 3.8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.963 84.959V160.925",
    stroke: "white",
    strokeWidth: 1.14651,
    strokeMiterlimit: 10,
    strokeDasharray: "3.8 3.8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.777 36.4131V112.379L212.823 126.738V50.7721",
    stroke: "white",
    strokeWidth: 1.14651,
    strokeMiterlimit: 10,
    strokeDasharray: "3.8 3.8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.016 70.3254V146.291",
    stroke: "white",
    strokeWidth: 1.14651,
    strokeMiterlimit: 10,
    strokeDasharray: "3.8 3.8"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M187.664 303.908L212.611 318.292L271.496 284.13L245.65 269.746L187.664 303.908Z",
    stroke: "white",
    strokeWidth: 1.14651,
    strokeMiterlimit: 10,
    strokeDasharray: "3.8 3.8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.664 379.874L212.611 394.258L271.496 360.096L245.65 345.712L187.664 379.874Z",
    stroke: "#231F20",
    strokeWidth: 1.14651,
    strokeMiterlimit: 10,
    strokeDasharray: "3.8 3.8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.807 379.874L212.754 394.258L271.639 360.096L245.792 345.712L187.807 379.874Z",
    stroke: "white",
    strokeWidth: 1.14651,
    strokeMiterlimit: 10,
    strokeDasharray: "3.8 3.8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.611 318.292V394.258",
    stroke: "white",
    strokeWidth: 1.14651,
    strokeMiterlimit: 10,
    strokeDasharray: "3.8 3.8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.426 269.746V345.712L271.472 360.071V284.105",
    stroke: "white",
    strokeWidth: 1.14651,
    strokeMiterlimit: 10,
    strokeDasharray: "3.8 3.8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.664 303.658V379.624",
    stroke: "white",
    strokeWidth: 1.14651,
    strokeMiterlimit: 10,
    strokeDasharray: "3.8 3.8"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M138.686 269.838L163.633 284.222L222.517 250.06L196.671 235.676L138.686 269.838Z",
    stroke: "white",
    strokeWidth: 1.14653,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.686 345.804L163.633 360.188L222.517 326.026L196.671 311.642L138.686 345.804Z",
    stroke: "white",
    strokeWidth: 1.14653,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.828 345.804L163.775 360.188L222.66 326.026L196.814 311.642L138.828 345.804Z",
    stroke: "white",
    strokeWidth: 1.14653,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.633 284.222V360.187",
    stroke: "white",
    strokeWidth: 1.14653,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.447 235.676V311.641L222.493 326V250.035",
    stroke: "white",
    strokeWidth: 1.14653,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.686 269.588V345.554",
    stroke: "white",
    strokeWidth: 1.14653,
    strokeMiterlimit: 10
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M174.825 208.608C168.959 211.325 167.265 210.635 161.13 212.808C157.936 213.939 152.92 215.716 147.982 219.747C143.933 223.052 139.626 226.568 139.217 232.164C138.859 237.062 141.624 241.663 144.878 244.216C147.884 246.575 150.317 246.408 157.843 248.051C157.843 248.051 164.45 249.494 171.721 251.886C183.666 255.815 183.905 259.539 196.555 264.303C203.202 266.806 207.601 268.398 213.355 267.407C214.7 267.176 222.071 265.907 226.503 259.92C227.15 259.046 227.917 257.317 229.424 253.894C232.82 246.185 234.517 242.331 234.355 240.381C233.962 235.672 230.107 232.485 224.859 228.147C221.805 225.623 218.928 224.09 213.172 221.025C207.93 218.233 205.257 216.833 202.764 216.643C201.721 216.563 199.313 216.501 196.19 215.547C196.19 215.547 194.661 215.08 193.268 214.451C186.924 211.587 185.677 206.238 181.581 205.686C179.713 205.435 179.43 206.475 174.825 208.608Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M303.798 290.965C300.698 293.84 297.688 293.212 293.207 294.617C290.7 295.403 283.987 297.508 282.616 302.469C281.644 305.989 283.517 310.377 286.816 312.513C290.853 315.127 296.229 313.854 299.233 311.417C303.647 307.837 301.987 302.518 306.538 300.095C308.881 298.848 309.676 300.07 313.111 298.817C317.112 297.359 321.819 293.594 321.146 290.417C320.575 287.726 316.363 286.506 314.39 286.217C310.567 285.659 307.578 287.492 306.538 288.226C305.091 289.248 305.007 289.844 303.798 290.965Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M280.241 264.303C279.039 267.23 282.912 269.247 283.162 274.529C283.282 277.048 282.45 277.601 279.145 285.12C276.495 291.151 274.763 295.143 273.667 300.094C272.903 303.542 272.236 306.556 272.571 310.32C273.071 315.941 276.105 326.59 284.258 328.946C291.848 331.139 299.444 324.864 300.693 323.833C303.531 321.488 306.227 317.987 307.632 316.163C311.278 311.428 311.186 310.208 313.475 308.859C316.118 307.301 318.945 307.334 324.431 307.398C329.757 307.461 330.371 308.215 332.101 307.398C335.782 305.659 337.809 299.967 336.848 295.346C335.743 290.031 330.907 287.201 327.353 285.12C322.534 282.299 317.19 280.953 309.092 278.912C304.673 277.798 302.78 277.531 301.058 275.625C298.438 272.726 299.868 270.082 297.04 266.129C296.483 265.35 293.885 261.72 289.371 261.016C286.044 260.498 281.382 261.524 280.241 264.303Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M295.853 280.738C293.572 281.632 293.85 283.292 289.919 286.947C286.989 289.67 286.429 289.125 283.984 291.512C282.389 293.069 279.58 295.811 278.506 300.186C277.55 304.078 278.454 307.277 279.236 310.046C280.036 312.878 280.654 315.065 282.706 316.894C285.377 319.275 288.679 319.404 289.827 319.451C296.738 319.73 301.685 314.392 302.062 313.972C305.42 310.237 304.491 307.662 308.088 305.207C308.636 304.833 308.902 304.727 314.662 302.925C321.872 300.669 323.326 300.251 324.796 298.633C325.318 298.06 326.964 296.195 327.079 293.429C327.21 290.302 325.296 288.112 324.705 287.494C323.388 286.119 321.815 285.427 318.679 284.664C312.103 283.064 310.897 284.126 305.531 282.929C299.577 281.601 298.466 279.714 295.853 280.738Z",
    fill: "white"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M366.09 303.72L286.808 349.432L99.6719 240.865L181.812 195.152L366.09 303.72Z",
    fill: "white"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M165.744 216.237C159.772 217.94 156.728 218.821 153.874 220.254C149.098 222.654 146.517 223.951 145.474 226.828C143.996 230.905 146.53 235.607 149.126 238.15C153.007 241.95 158.215 242.092 160.996 242.167C170.634 242.429 172.805 237.07 180.352 238.332C184.95 239.102 183.971 241.062 191.674 243.811C196.566 245.556 203.071 247.777 208.838 244.906C209.904 244.376 212.711 242.929 214.134 239.793C216.563 234.442 212.807 228.922 212.491 228.472C210.373 225.461 207.475 224.218 206.282 223.724C202.034 221.965 200.194 223.402 191.674 222.446C188.217 222.058 186.489 221.864 184.917 221.167C179.926 218.956 179.864 215.464 175.969 214.228C175.214 213.989 174.247 213.812 165.744 216.237Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M171.59 222.213C165.63 220.44 160.316 223.337 159.721 223.673C158.037 224.624 156.162 225.684 155.886 227.508C155.492 230.111 158.563 232.877 161.364 233.899C164.681 235.11 167.937 233.991 170.859 232.986C175.748 231.306 176.249 229.529 179.442 229.517C181.273 229.51 182.915 230.273 186.198 231.799C191.178 234.114 192.37 235.783 194.872 235.36C196.371 235.107 198.194 234.128 198.433 232.712C198.668 231.323 197.284 230.06 196.789 229.608C195.549 228.476 194.189 228.031 188.572 227.143C184.57 226.51 184.064 226.546 182.09 226.047C180.195 225.568 178.703 225.04 177.433 224.586C173.462 223.169 173.37 222.742 171.59 222.213Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M300.791 299.74C300.003 299.517 299.413 299.35 298.766 299.167C299.981 297.186 301.159 295.266 302.386 293.268C301.759 293.111 301.241 292.981 300.636 292.829C301.772 290.717 302.884 288.648 304.046 286.486C303.339 286.382 302.754 286.296 301.963 286.18C304.479 282.626 305.94 278.654 307.456 274.469C309.036 278.607 310.414 282.618 313.003 286.178C312.211 286.291 311.609 286.377 310.886 286.48C312.044 288.622 313.154 290.676 314.313 292.82C313.741 292.965 313.228 293.094 312.548 293.266C313.77 295.252 314.96 297.185 316.184 299.174C315.515 299.36 314.924 299.524 314.151 299.738C315.698 301.943 317.185 304.062 318.814 306.383H309.071V314.047H305.899V306.438H296.092C297.734 304.096 299.223 301.975 300.791 299.74Z",
    fill: "white",
    stroke: "#754D29",
    strokeWidth: 2.29305,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M280.004 311.475C278.676 311.099 277.684 310.817 276.593 310.508C278.64 307.173 280.625 303.939 282.69 300.574C281.635 300.309 280.763 300.09 279.744 299.834C281.656 296.278 283.529 292.792 285.486 289.151C284.295 288.976 283.311 288.832 281.978 288.636C286.216 282.651 288.676 275.962 291.23 268.912C293.891 275.882 296.212 282.637 300.572 288.633C299.239 288.823 298.223 288.968 297.006 289.141C298.957 292.75 300.826 296.208 302.779 299.819C301.815 300.063 300.951 300.281 299.805 300.571C301.864 303.916 303.868 307.171 305.929 310.521C304.803 310.834 303.808 311.11 302.506 311.472C305.112 315.185 307.615 318.753 310.358 322.662H293.95V335.57H288.608V322.755H272.09C274.856 318.811 277.363 315.239 280.004 311.475Z",
    fill: "white",
    stroke: "#754D29",
    strokeWidth: 2.29305,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M238.306 226.968C236.979 226.592 235.986 226.311 234.896 226.002C236.943 222.666 238.928 219.432 240.993 216.067C239.938 215.802 239.066 215.583 238.047 215.327C239.958 211.771 241.832 208.286 243.789 204.645C242.598 204.47 241.614 204.325 240.281 204.129C244.519 198.144 246.979 191.455 249.533 184.405C252.194 191.375 254.515 198.13 258.875 204.127C257.541 204.316 256.526 204.461 255.309 204.634C257.26 208.243 259.129 211.701 261.081 215.312C260.118 215.556 259.253 215.775 258.108 216.064C260.167 219.409 262.17 222.665 264.232 226.014C263.105 226.327 262.11 226.603 260.809 226.965C263.414 230.678 265.918 234.246 268.661 238.155H252.253V251.063H246.911V238.248H230.393C233.159 234.304 235.665 230.732 238.306 226.968Z",
    fill: "white",
    stroke: "#754D29",
    strokeWidth: 2.29305,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M226.216 248.358C225.428 248.134 224.839 247.967 224.191 247.784C225.407 245.804 226.585 243.883 227.811 241.885C227.185 241.728 226.667 241.598 226.062 241.446C227.197 239.334 228.31 237.265 229.471 235.103C228.765 234.999 228.18 234.913 227.389 234.797C229.905 231.243 231.366 227.272 232.882 223.086C234.462 227.224 235.84 231.235 238.429 234.795C237.637 234.908 237.034 234.994 236.312 235.097C237.47 237.24 238.58 239.293 239.739 241.437C239.167 241.582 238.654 241.711 237.974 241.883C239.196 243.869 240.386 245.802 241.61 247.791C240.941 247.977 240.35 248.141 239.577 248.356C241.124 250.56 242.611 252.679 244.24 255H234.497V262.664H231.325V255.055H221.518C223.16 252.714 224.648 250.593 226.216 248.358Z",
    fill: "white",
    stroke: "#754D29",
    strokeWidth: 2.29305,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M165.134 215.929C163.968 215.599 163.096 215.352 162.139 215.08C163.936 212.151 165.679 209.311 167.493 206.356C166.566 206.123 165.801 205.931 164.906 205.706C166.585 202.582 168.23 199.521 169.949 196.324C168.903 196.17 168.038 196.043 166.868 195.871C170.59 190.615 172.751 184.74 174.993 178.549C177.331 184.67 179.369 190.602 183.198 195.869C182.027 196.036 181.135 196.163 180.066 196.315C181.78 199.484 183.421 202.521 185.136 205.693C184.289 205.907 183.53 206.099 182.525 206.353C184.333 209.291 186.092 212.15 187.902 215.091C186.913 215.366 186.039 215.609 184.896 215.926C187.185 219.187 189.384 222.321 191.793 225.754H177.382V237.09H172.691V225.835H158.184C160.613 222.372 162.814 219.235 165.134 215.929Z",
    fill: "white",
    stroke: "#754D29",
    strokeWidth: 2.29305,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M148.262 222.91C146.934 222.533 145.941 222.252 144.851 221.943C146.898 218.608 148.883 215.374 150.948 212.009C149.893 211.744 149.021 211.525 148.002 211.269C149.914 207.712 151.787 204.227 153.744 200.586C152.553 200.411 151.569 200.266 150.236 200.07C154.474 194.085 156.934 187.396 159.488 180.347C162.149 187.317 164.47 194.071 168.83 200.068C167.497 200.258 166.481 200.402 165.264 200.576C167.215 204.184 169.084 207.642 171.037 211.254C170.073 211.497 169.209 211.716 168.063 212.005C170.122 215.351 172.125 218.606 174.187 221.955C173.061 222.268 172.065 222.545 170.764 222.906C173.369 226.619 175.873 230.187 178.616 234.096H162.208V247.004H156.866V234.189H140.348C143.114 230.246 145.62 226.674 148.262 222.91Z",
    fill: "white",
    stroke: "#754D29",
    strokeWidth: 2.29305,
    strokeMiterlimit: 10
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobile);
export default __webpack_public_path__ + "static/media/mobile.966ff9efd48f3aaea5f61c1ef658672a.svg";
export { ForwardRef as ReactComponent };